<!--
 * @Description: 左侧纵向深色菜单（2026-11 改版）：保留后端权限过滤逻辑
 * @FilePath: /sunpay-web/src/components/layout/TopMenu.vue
-->


<template>
  <el-scrollbar class="side-menu-scroll">
    <el-menu
      class="side-el-menu"
      :default-active="state.toIndex"
      :collapse="collapsed"
      :collapse-transition="false"
      unique-opened
      @select="jump"
    >
      <template v-for="item in state.menu" :key="item.name">
        <el-menu-item
          :index="item.path"
          v-if="item && item.meta && !item.meta.hidden && (!item.meta.children || !item.meta.isRoot)"
        >
          <el-icon :size="16">
            <component :is="menuIcon(item)" />
          </el-icon>
          <template #title>
            <!-- 标题必须包在 span 内：EP 折叠态靠 > span 选择器隐藏标题文本 -->
            <span>
              <el-badge v-if="item.count" :value="item.count" :max="99">{{ item.meta?.title }}</el-badge>
              <template v-else>{{ item.meta?.title }}</template>
            </span>
          </template>
        </el-menu-item>
        <el-sub-menu
          :index="item.path"
          v-if="item && item.meta && !item.meta.hidden && item.meta.children && item.meta.isRoot"
        >
          <template #title>
            <el-icon :size="16">
              <component :is="menuIcon(item)" />
            </el-icon>
            <span>
              <el-badge v-if="item.count" :value="item.count" :max="99">{{ item.meta.title }}</el-badge>
              <template v-else>{{ item.meta.title }}</template>
            </span>
          </template>
          <el-menu-item v-for="i in visibleChildren(item)" :key="i.name" :index="i.path"
            :class="[state.toIndex === i.path ? 'active' : '', 'children']"
            >
            {{ i.meta?.title }}
          </el-menu-item>
        </el-sub-menu>
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script setup>
import { computed, reactive, onMounted } from "vue"
import { useStore } from "vuex"
import { useRoute, useRouter } from "vue-router"
import { routes } from "@/router"
import { flattenTreeData } from "@/service"
import {
  Odometer,
  CreditCard,
  User,
  Warning,
  Tickets,
  DataAnalysis,
  DocumentChecked,
  Menu as MenuIcon,
} from "@element-plus/icons-vue"

defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
})

/* 顶层菜单图标映射（按路由 path，新增菜单在此补充） */
const iconMap = {
  "/": Odometer,
  "/system/users": User,
  "/payment/pay": CreditCard,
  "/risk-manager": Warning,
  "/rdr_manage": Tickets,
  "/report-manager": DataAnalysis,
  "/reconcile-manager": DocumentChecked,
}
const menuIcon = (item) => iconMap[item.path] || MenuIcon
const visibleChildren = (item) => (item.children || []).filter(i => !i.meta?.hidden)

const state = reactive({
  menu: [],
  toIndex: "/home",
  approveCount: 0,
})
const $route = useRoute(),
  $router = useRouter()
const store = useStore()

onMounted(() => {
  getMenus()
  state.toIndex = computed(() => {
    let path = $route.matched[1].path
    if (path == '/dashboard') {
      path = '/'
    }
    return path
  })
})

const getMenus = () => {
  store.dispatch('GetUserAuthor').then(res => {
    const menus = flattenTreeData(res)
    const copyRoutes = deepCopy(routes)
    mapRouterMenu(copyRoutes, menus)
  })
}

const deepCopy = (obj) => {
  if (typeof obj !== 'object') return;
  var newObj = obj instanceof Array ? [] : {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = typeof obj[key] === 'object' ? deepCopy(obj[key]) : obj[key];
    }
  }
  return newObj
}

const mapRouterMenu = (route, menus) => {
  let arr = []
  for (let current in route) {
    let rItem = route[current]
    if (!rItem.code) {
      arr.push(rItem)
    } else {
      if (rItem.children && rItem.children.length > 0) {
        rItem.children = rItem.children.filter(item => {
          return menus.find(v => v.path == item.path)
        })
        if (rItem.children.length > 0) {
          arr.push(rItem)
        }
      }
    }
  }
  state.menu = arr
}

const jump = index => {
  let path = index
  // 点击"控制台"菜单时，固定跳到 /dashboard（避免命中根路由 redirect() 跳转到 firstMenuPath=/user/list）
  if (path === '/' || (path && path.replace(/\/+$/, '') === '')) {
    path = '/dashboard'
  }
  let value = flattenTreeData(store.state.menu)
  const current = value.find(i => i.path === path)
  const allRoutes = flattenTreeData(routes)
  const routeItem = allRoutes.find(r => r.path === path)
  const tabName = (routeItem && routeItem.meta && routeItem.meta.title)
    || (current && current.name)
    || (routeItem && routeItem.name)
    || path
  const visitedTab = current
    ? { ...current, name: tabName, path: path }
    : { path: path, name: tabName }
  store.commit("SET_VISITEDMENU", visitedTab)
  $router.push({ path })
}
</script>
<style lang="less" scoped>
.side-menu-scroll {
  flex: 1;
  background: transparent;
  :deep(.el-scrollbar__wrap) {
    overflow-x: hidden;
  }
}
.side-el-menu {
  border-right: none;
  background: transparent;
  width: 100%;
  &:not(.el-menu--collapse) {
    width: 100%;
  }
  :deep(.el-menu--vertical:not(.el-menu--collapse):not(.el-menu--popup-container)) {
    .el-menu-item,
    .el-sub-menu__title {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  :deep(.el-menu-item),
  :deep(.el-sub-menu__title) {
    height: 36px;
    line-height: 36px;
    margin: 1px 8px;
    padding: 0 10px;
    border-radius: @radius-s;
    color: @sidebar-text;
    font-size: 14px;
    gap: 8px;
    &:hover {
      background: @sidebar-hover;
      color: #fff;
    }
  }
  :deep(.el-sub-menu.is-active > .el-sub-menu__title) {
    color: #fff;
  }
  :deep(.el-menu-item) {
    &.is-active,
    &.active {
      background: @primary;
      color: #fff;
      font-weight: 500;
      &:hover {
        background: @primary;
      }
    }
    .el-badge {
      vertical-align: middle;
    }
  }
  :deep(.el-sub-menu .el-menu) {
    background: transparent;
  }
  :deep(.el-sub-menu .el-menu-item) {
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    padding-left: 30px !important;
    min-width: 0;
  }
  :deep(.el-menu--collapse .el-menu-item),
  :deep(.el-menu--collapse .el-sub-menu__title) {
    margin: 1px 8px;
    padding: 0;
    justify-content: center;
  }
  :deep(.el-menu--collapse .el-sub-menu.is-active .el-sub-menu__title) {
    box-shadow: inset 2px 0 0 @primary;
    color: #fff;
  }
}
</style>
